'use client';

import { Portal } from '@common/components';
import { cn } from '@core/utils';
import { motion } from 'framer-motion';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

import { PrizeQuickMenu } from '@/app/donation/event/stamp/_components/PrizeQuickMenu';
import { DONATION_ROUTES, SELECTOR } from '@/constants';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
import { useAuthStore } from '@/stores/AuthStore';
import { checkTodayInRange } from '@/utils/checkTodayInRange';

export const PrizeQuickMenuController = () => {
  const pathname = usePathname();
  const isLoading = useAuthStore((state) => state.isLogin === undefined);
  const [displayQuickMenu, setDisplayQuickMenu] = useState(false);
  const { entry } = useWebviewTypeEntry();

  const isStampDisplayed = checkTodayInRange(
    '2025-11-03T00:00:00',
    '2025-11-30T23:59:59',
  );

  useEffect(() => {
    if (!pathname || entry !== 'WELLO' || !isStampDisplayed) {
      setDisplayQuickMenu(false);

      return;
    }

    const isDonationMainRoute = pathname === DONATION_ROUTES.HOME.pathname;
    setDisplayQuickMenu(isDonationMainRoute);
  }, [pathname, entry, isStampDisplayed]);

  if (!displayQuickMenu) {
    return null;
  }

  return (
    <Portal
      renderTo={() => document.getElementById(SELECTOR.GLOBAL_NAVIGATION)}
    >
      <motion.div
        animate={displayQuickMenu ? 'show' : 'hide'}
        initial="hide"
        variants={{
          show: {
            opacity: 1,
          },
          hide: {
            opacity: 0,
          },
        }}
        transition={{
          type: 'spring',
          stiffness: 500,
          damping: 40,
        }}
        className={cn(
          'pointer-events-none fixed bottom-110 z-10 flex w-full justify-end pr-20',
          {
            invisible: isLoading,
          },
        )}
      >
        <div className="pointer-events-auto">
          <PrizeQuickMenu href={DONATION_ROUTES.STAMP.pathname} />
        </div>
      </motion.div>
    </Portal>
  );
};
